import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { publishersManageService } from '../api/publishersManageService';
import type { ManagePublishersListResult, PublisherFilterState } from '../types/managePublishers';

export function usePublisherListQuery(filters: PublisherFilterState) {
  return useQuery<ManagePublishersListResult>({
    queryKey: ['manage-publishers', filters],
    queryFn: () => publishersManageService.list(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
